<template>
    <div class="benefit">
        <h1>
            바이엘 팜파트너 가입 회원의<br />
            특별한 혜택과 서비스
        </h1>
        <p>
            안녕하세요! 바이엘 팜파트너입니다.<br />
            회원님의 귀한 농사 여정에 바이엘이 함께 하겠습니다.
        </p>
        <v-row>
            <v-col>
                <div>
                    <div>
                        <img src="@/assets/images/bayer/main/icon_benefit1.png" alt="">
                    </div>
                </div>
                <h5>상품권 증정</h5>
                <p>
                    회원 가입시 농협 농촌 사랑
                    모바일 상품권 증정<br />
                    (10,000원 상당)
                </p>
            </v-col>
            <v-col>
                <div>
                    <div>
                        <img src="@/assets/images/bayer/main/icon_benefit2.png" alt="">
                    </div>
                </div>
                <h5>맞춤 뉴스 제공</h5>
                <p>
                    바이엘의 혁신적인
                    병해충 관리 정보 및
                    기술정보 맞춤 제공
                </p>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <div>
                    <div>
                        <img src="@/assets/images/bayer/main/icon_benefit3.png" alt="">
                    </div>
                </div>
                <h5>참여</h5>
                <p>
                    바이엘 이벤트 참여
                    및 행사 특별 초청
                    등의 혜택 제공
                </p>
            </v-col>
            <v-col>
                <div>
                    <div>
                        <img src="@/assets/images/bayer/main/icon_benefit4.png" alt="">
                    </div>
                </div>
                <h5>회원 전용 상담</h5>
                <p>
                    회원님을 위한
                    1:1 문의 최우선 응대

                </p>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.benefit {
    text-align: center;
    margin: 40px 0;
    padding: 20px;

    h1 {
        font-size: 26px;

        &+p {
            font-size: 14px;
            color: #666666;
            margin-bottom: 40px;
        }
    }

    .row {
        padding-bottom: 20px;
        align-items: start;
        justify-content: center;

        .col {
            max-width: 150px;

            img {
                width: 33px;
            }

            h5 {
                font-size: 20px;
            }

            p {
                font-size: 16px;
                word-break: keep-all;
            }
        }
    }
}
</style>